let audioCtx: AudioContext | null = null;
let lastChimeAt = 0;

export function playChime() {
  if (Date.now() - lastChimeAt < 1000) return;
  lastChimeAt = Date.now();

  if (!audioCtx) audioCtx = new AudioContext();
  const ctx = audioCtx;

  const now = ctx.currentTime;
  const gain = ctx.createGain();
  gain.connect(ctx.destination);
  gain.gain.setValueAtTime(0.15, now);
  gain.gain.exponentialRampToValueAtTime(0.001, now + 0.4);

  const playNote = (freq: number, start: number, duration: number) => {
    const osc = ctx.createOscillator();
    osc.type = 'sine';
    osc.frequency.setValueAtTime(freq, start);
    osc.connect(gain);
    osc.start(start);
    osc.stop(start + duration);
  };

  playNote(523.25, now, 0.12);        // C5
  playNote(659.25, now + 0.13, 0.15); // E5
}
